__turbopack_context__.v({
  "absoluteLoader": "Button-module__wti9sq__absoluteLoader",
  "borderMin": "Button-module__wti9sq__borderMin",
  "button": "Button-module__wti9sq__button",
  "danger": "Button-module__wti9sq__danger",
  "disabled": "Button-module__wti9sq__disabled",
  "full": "Button-module__wti9sq__full",
  "ghost": "Button-module__wti9sq__ghost",
  "iconOnly": "Button-module__wti9sq__iconOnly",
  "min": "Button-module__wti9sq__min",
  "muted": "Button-module__wti9sq__muted",
  "outline": "Button-module__wti9sq__outline",
  "outlineLight": "Button-module__wti9sq__outlineLight",
  "responsiveLink": "Button-module__wti9sq__responsiveLink",
  "selected": "Button-module__wti9sq__selected",
  "soft": "Button-module__wti9sq__soft",
  "softGreen": "Button-module__wti9sq__softGreen",
});
